import React from 'react'
import { SelectAsyncCreatable } from '@ztechapps/webui.input'
import { VendorSelect } from './VendorSelect'
import type { VendorSelectCreatableProps } from '@ztechapps/webui.contract'

export const VendorSelectCreatable = ({ showInfo = true, ...rest }: VendorSelectCreatableProps) => {
  return <VendorSelect showInfo={showInfo} {...rest} As={SelectAsyncCreatable} />
}
